<template>
  <el-button
    type="primary"
    @click="exportList"
    icon="el-icon-download"
    data-qa="export-to-csv-button"
  >
    {{ $t('Lists_ListItemsList_Export') }}
  </el-button>
</template>

<script>
import RestApi from '@/core/services/RestApi'
import { projectEndpoint, projectRoute } from '@/core/helpers'

export default {
  props: {
    listId: {
      required: true
    }
  },

  methods: {
    exportList() {
      RestApi(
        projectEndpoint({
          method: 'get',
          url: `lists/${this.listId}/export`
        })
      )
        .then(({ data }) => {
          this.$router.push(
            projectRoute({
              name: 'TaskHistoryView',
              query: { id: data }
            })
          )
        })
        .catch(error => {
          this.$message({
            message: error.message,
            type: 'error'
          })
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/audiences/components/ListExportButton.vue